import cardConfig from 'molecules/ImageCard/config';

import type { Input } from '@builder.io/sdk';

const iconCardFields = [
  {
    name: 'headingTag',
    type: 'string',
    enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    defaultValue: 'h3',
    helperText: "Select the HTML heading tag for the cards' titles",
  },
  {
    name: 'cards',
    type: 'list',
    subFields: cardConfig.inputs,
  },
] as const satisfies DeepReadonly<Input[]>;

const iconCardsConfig = {
  name: 'Icon Cards',
  inputs: iconCardFields,
};

export type IconCardsProps = GenerateBuilder<typeof iconCardFields>;

export default iconCardsConfig;
